export const SITE_NAME = "Digipank Pvt. Ltd.";

export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.digipank.com"
).replace(/\/$/, "");

export const DEFAULT_DESCRIPTION =
  "Digipank delivers mobile app development, web development, UI/UX design, AI automation, cloud solutions, and SEO services for growing businesses.";

export const DEFAULT_OG_IMAGE = "/logo512.png";

export const PAGE_SEO = {
  home: {
    title: "Mobile, Web & AI Development Company",
    description:
      "Digipank builds mobile apps, web platforms, UI/UX, AI solutions, and cloud products. Partner with us for end-to-end digital transformation.",
    path: "/",
  },
  about: {
    title: "About Us",
    description:
      "Learn about Digipank — our team, culture, and mission to deliver innovative software, AI, and digital solutions.",
    path: "/aboutus",
  },
  services: {
    title: "Our Services",
    description:
      "Explore Digipank services: mobile apps, web development, UI/UX design, marketing, and enterprise software solutions.",
    path: "/ourservices",
  },
  seoPackages: {
    title: "SEO & Digital Marketing Packages",
    description:
      "SEO, PPC, social media, and content marketing packages to grow organic traffic and qualified leads.",
    path: "/packagesseo",
  },
  ios: {
    title: "iOS App Development",
    description:
      "Native iOS app development services — design, engineering, testing, and App Store launch support.",
    path: "/iosdevelopment",
  },
  blog: {
    title: "Blog",
    description:
      "Insights on AI, software engineering, cloud, SEO, and digital product strategy from the Digipank team.",
    path: "/bloglisting",
  },
  portfolio: {
    title: "Portfolio",
    description:
      "Explore Digipank client work across mobile apps, web platforms, and digital products.",
    path: "/portfolio",
  },
  portfolioListing: {
    title: "Portfolio Projects",
    description: "Browse our portfolio of mobile, web, and enterprise software projects.",
    path: "/portfoliolisting",
  },
  career: {
    title: "Careers",
    description:
      "Join Digipank. Explore open roles in software development, design, and digital marketing.",
    path: "/career",
  },
  contact: {
    title: "Contact Us",
    description:
      "Contact Digipank for project inquiries, partnerships, and consultations.",
    path: "/contactpage",
  },
  privacy: {
    title: "Privacy Policy",
    description: "Digipank privacy policy — how we collect, use, and protect your data.",
    path: "/privacy",
  },
  terms: {
    title: "Terms & Conditions",
    description: "Terms and conditions for using Digipank website and services.",
    path: "/termcondition",
  },
  verifyCertificate: {
    title: "Verify Certificate",
    description: "Verify authenticity of Digipank training and internship certificates.",
    path: "/verifycertificate",
  },
  captionPublishing: {
    title: "Caption Publishing",
    description:
      "Upload video, generate subtitles, and download YouTube-ready SRT or VTT caption files.",
    path: "/captionPublishing",
  },
};
